import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
import { GetAllchannalData } from '../Redux/Actions/ChannalActions';
import { GetallProjectsdata } from '../Redux/Actions/Projects_Action';
import BeenhereIcon from '@mui/icons-material/Beenhere';
import { Switch, TextField } from '@mui/material';
import { Add_Rotation_Action } from '../Redux/Actions/Rotations_Actions';
import { Notify } from '../Utility/Notify';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import { GetDevelopersData } from '../Redux/Actions/DevelopersAction';

const ITEM_HEIGHT = 130;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const RotationPage = () => {
  const [userlogin, setuserlogin] = useState('');
  useEffect(() => {
    if (JSON.parse(localStorage.getItem('user')) != null) {
      setuserlogin(JSON.parse(localStorage.getItem('user')));
    }
  }, []);

  const dispatch = useDispatch();

  // sales

  const getAll = async () => {
    await dispatch(Get_All_Sales_Action());
    await dispatch(GetAllchannalData());
    await dispatch(GetallProjectsdata());
    await dispatch(GetDevelopersData());
  };

  useEffect(() => {
    getAll();
  }, []);

  const resallsales = useSelector((state) => state.AllSales.sales);
  const reschannel = useSelector((state) => state.AllChannalRoot.channal);
  const resAllProjects = useSelector((state) => state.AllProjects.Projects);
  const resAllDevelopers = useSelector((state) => state.AllDevelopers.Developers);

  let allsales = Array.isArray(resallsales?.data) ? resallsales.data : [];
  let allChannel = Array.isArray(reschannel?.data) ? reschannel.data : [];
  let allProjects = Array.isArray(resAllProjects?.data) ? resAllProjects.data : [];
  let alldevelopers = Array.isArray(resAllDevelopers?.data) ? resAllDevelopers.data : [];

  const [personName, setPersonName] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };
  // console.log(personName,"sales")

  // ===================================================================================
  // channel

  const [chanelname, setchanelname] = React.useState([]);

  const handlechanelChange = (event) => {
    const {
      target: { value },
    } = event;
    setchanelname(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };
  // console.log(chanelname,"chanel")

  // ///////////////////////////////////////////////////////////////
  // Projects

  const [projectname, setprojectname] = React.useState([]);

  const handleprojectChange = (event) => {
    const {
      target: { value },
    } = event;
    setprojectname(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };
  // console.log(projectname,"project")

  // =====================================================================

  // developer

  const [devlopername, setdevelopername] = React.useState([]);

  const handledeveloperChange = (event) => {
    //       const {
    //         target: { value },
    //       } = event;
    //       setdevelopername(
    //         // On autofill we get a stringified value.
    //         typeof value === 'string' ? value.split(',') : value,
    //       );
    //     };
    //   console.log(devlopername,"developer name")

    const {
      target: { value },
    } = event;
    setdevelopername(value);

    // تصفية المشاريع بناءً على الـ developerId
    if (value.length > 0) {
      const selectedDeveloperIds = value; // الحصول على الـ developerIds المختارة
      const filteredProjects = allProjects.filter((project) =>
        selectedDeveloperIds.includes(project.developer?._id),
      );
      setprojectname(filteredProjects.map((project) => project._id)); // تعيين الـ projectIds الخاصة بالمطورين المختارين
    } else {
      setprojectname([]); // إلغاء تحديد المشاريع إذا لم يتم اختيار مطور
    }
  };

  // =====================================================================
  const [loading, setloading] = useState(true);
  const [rotationtime, setrotationtime] = useState(0);

  const handlerotationtime = (e) => {
    setrotationtime(e.target.value);
  };

  // switch active or not active
  const [checked, setChecked] = React.useState(true);
  const handleChangeswitch = (event) => {
    setChecked(event.target.checked);
  };
  const AddRotation = async (e) => {
    if (rotationtime === 0) {
      Notify('error', 'Rotation Time  Is Required', 'error');
      return;
    } else if (personName.length === 0) {
      Notify('error', 'Sales Name Is Required', 'error');
      return;
    } else if (chanelname.length === 0) {
      Notify('error', 'Channel Name Is Required', 'error');
      return;
    } else if (projectname.length === 0) {
      Notify('error', 'Project Name Is Required', 'error');
      return;
    }

    e.preventDefault();
    setloading(true);

    try {
      // تضمين maxLeads مع كل salesId
      const salesWithMaxLeads = personName.map((salesId) => ({
        salesId: salesId, // salesId هو الـ ObjectId الخاص بـ Sales
        maxLeads: rotationtime, // القيمة المحددة لـ maxLeads، ويمكن تعديلها حسب الحاجة
        assignedLeads: 0, // قيمة البداية لـ assignedLeads
      }));

      await dispatch(
        Add_Rotation_Action({
          sales: salesWithMaxLeads, // إرسال الـ sales مع maxLeads
          channels: chanelname, // القناة المختارة
          projects: projectname, // المشروع المختار
          active: checked,
        }),
      );
    } catch (error) {
      console.error('Error adding rotation:', error);
    } finally {
      setloading(false);
    }
  };

  const resallrotation = useSelector((state) => state.AllRotation.Rotation);

  useEffect(() => {
    if (loading === false) {
      if (resallrotation && resallrotation.status === 201) {
        Notify('success', 'Rotation Added Successfully', 'success');
        setPersonName([]);
        setchanelname([]);
        setprojectname([]);
        setrotationtime(0);
      } else {
        Notify('error', 'Failed to Add Rotation', 'error');
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      }
    }
  }, [loading]);

  // تحديد كل ال projects
  const selectAllProjects = () => {
    // نقوم بتحديد كل المشاريع هنا
    const allProjectIds = allProjects.map((project) => project._id); // استخراج كل الـ ID للمشاريع
    setprojectname(allProjectIds); // تعيين كل الـ ID في الـ state
    setshowcancelproject(true);
  };

  //   تحديد كل ال channels
  const selectAllchannels = () => {
    const allchannelsIds = allChannel.map((channel) => channel._id); // استخراج كل الـ ID للمشاريع
    setchanelname(allchannelsIds); // تعيين كل الـ ID في الـ state
    setshowcancelchannel(true);
  };

  //   تحديد كل ال sales
  const selectAllsales = () => {
    const allsalesIds = allsales.map((sales) => sales._id); // استخراج كل الـ ID للمشاريع
    setPersonName(allsalesIds); // تعيين كل الـ ID في الـ state
    setShowCancelSales(true);
  };

  const [showCancelSales, setShowCancelSales] = React.useState(false);
  const [showcancelchanel, setshowcancelchannel] = React.useState(false);
  const [showcancelproject, setshowcancelproject] = React.useState(false);

  // cancel sales
  const cancelSales = () => {
    setPersonName([]);
    setShowCancelSales(false);
  };

  // cancel channel
  const cancelchannel = () => {
    setchanelname([]);
    setshowcancelchannel(false);
  };

  // cancel project
  const cancelproject = () => {
    setprojectname([]);
    setshowcancelproject(false);
  };

  const rotationRoute =
    userlogin?.data?.role === 'Admin'
      ? '/AllLeadsForAdmin' // Admin يذهب إلى /Rotation
      : userlogin?.data?.role === 'Marketer'
        ? '/ALLLeadsForMarketer' // Marketer يذهب إلى /MarketerRotation
        : '/'; // مسار افتراضي لأي دور آخر

  return (
    <Container className="startpage" style={{ marginTop: '100px' }}>
      <div>
        <Link
          to={rotationRoute}
          style={{ textDecoration: 'none', color: '#102dff', fontWeight: 'bold' }}
        >
          <span style={{ fontWeight: 'bold' }}>Home</span>
        </Link>
        <KeyboardDoubleArrowRightIcon />

        <span style={{ color: '#666' }}>Rotation</span>
      </div>
      <div className="d-flex justify-content-between flex-wrap my-4 rotationcontainer">
        <div className="rotationcontainer">
          <div
            className="btn btn-error rotationbtn"
            style={{ background: '#102dff' }}
            onClick={selectAllsales}
          >
            All Sales
          </div>

          <div
            className="btn btn-error rotationbtn"
            style={{ background: '#102dff' }}
            onClick={selectAllchannels}
          >
            All Chanels
          </div>
          <div
            className="btn btn-error  rotationbtn"
            style={{ background: '#102dff' }}
            onClick={selectAllProjects}
          >
            All Projects
          </div>
        </div>

        <Link to={`/manageRotation`} style={{ textDecoration: 'none' }}>
          <div className="btn btn-error rotationbtn " style={{ background: 'royalblue' }}>
            Manage Rotations <ManageHistoryIcon />
          </div>
        </Link>
      </div>

      <div className="d-flex justify-content-start flex-wrap">
        {/* cancel sales */}
        {showCancelSales && (
          <div
            className="btn btn-warning rotationbtn mx-2"
            style={{ background: '#FF5733', marginTop: '10px' }}
            onClick={cancelSales}
          >
            Cancel Sales {`${allsales.length}`} Selected
          </div>
        )}
        {/* ================================= */}
        {/* cancel channel */}

        {showcancelchanel && (
          <div
            className="btn btn-warning rotationbtn mx-2"
            style={{ background: '#FF5733', marginTop: '10px' }}
            onClick={cancelchannel}
          >
            Cancel Channel {`${allChannel.length}`} Selected
          </div>
        )}

        {/* ========================== */}

        {/* cancel project */}
        {showcancelproject && (
          <div
            className="btn btn-warning rotationbtn mx-2"
            style={{ background: '#FF5733', marginTop: '10px' }}
            onClick={cancelproject}
          >
            Cancel Projects {`${allProjects.length}`} Selected
          </div>
        )}
      </div>
      <br />

      <label className="m-3">Rotation Time :</label>
      <br />
      <TextField
        className="mx-1"
        required
        id="outlined-required"
        label="Rotation Times Required"
        defaultValue=""
        type="number"
        value={rotationtime}
        onChange={handlerotationtime}
      />

      {/* sales */}
      <div>
        <FormControl sx={{ m: 1, width: '100%' }}>
          <InputLabel id="demo-multiple-checkbox-label">Choose Sales</InputLabel>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={personName} // تخزين الـ ID هنا
            onChange={handleChange}
            input={<OutlinedInput label="Tag" />}
            renderValue={(selected) =>
              selected
                .map((id) => {
                  // عرض الـ name بناءً على الـ ID
                  const selectedItem = allsales.find((item) => item._id === id);
                  return selectedItem ? selectedItem.name : '';
                })
                .join(', ')
            }
            MenuProps={MenuProps}
          >
            {allsales.map((salesitem) => (
              <MenuItem key={salesitem._id} value={salesitem._id}>
                <Checkbox checked={personName.includes(salesitem._id)} />
                <ListItemText
                  primary={salesitem.name}
                  secondary={salesitem?.userlog?.role || 'No Role'}
                  secondaryTypographyProps={{
                    style: {
                      fontSize: '0.75rem',
                      color: '#666',
                    },
                  }}
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      {/* Developers */}
      {/* =============================================================== */}
      <div>
        <FormControl sx={{ m: 1, width: '100%' }}>
          <InputLabel id="demo-multiple-checkbox-label">Choose Developers</InputLabel>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={devlopername} // تخزين الـ ID هنا
            onChange={handledeveloperChange}
            input={<OutlinedInput label="Tag" />}
            renderValue={(selected) =>
              selected
                .map((id) => {
                  // عرض الـ name بناءً على الـ ID
                  const selectedItem = alldevelopers.find((item) => item._id === id);
                  return selectedItem ? selectedItem.name : '';
                })
                .join(', ')
            }
            MenuProps={MenuProps}
          >
            {alldevelopers.map((developeritem) => (
              <MenuItem key={developeritem._id} value={developeritem._id}>
                <Checkbox checked={devlopername.includes(developeritem._id)} />
                <ListItemText primary={developeritem.name} /> {/* المعروض في الواجهة هو الـ name */}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      {/* ==================================================== */}
      {/* chanel */}
      <div>
        <FormControl sx={{ my: 3, mx: 1, width: '100%' }}>
          <InputLabel id="demo-multiple-checkbox-label">Choose Channel</InputLabel>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={chanelname} // قيمة الـ ID هنا
            onChange={handlechanelChange}
            input={<OutlinedInput label="Tag" />}
            renderValue={
              (selected) =>
                selected
                  .map((id) => {
                    // عرض الـ name بناءً على الـ ID
                    const selectedItem = allChannel.find((item) => item._id === id);
                    return selectedItem ? selectedItem.name : '';
                  })
                  .join(', ') // دمج الأسماء مع الفاصلة بين كل عنصر
            }
            MenuProps={MenuProps}
          >
            {allChannel.map((channelitem) => (
              <MenuItem key={channelitem._id} value={channelitem._id}>
                <Checkbox checked={chanelname.includes(channelitem._id)} />
                <ListItemText primary={channelitem.name} /> {/* المعروض في الواجهة هو الـ name */}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      {/* ============================================================= */}
      {/* projects */}

      <div>
        <FormControl sx={{ mx: 1, width: '100%' }}>
          <InputLabel id="demo-multiple-checkbox-label">Choose Project</InputLabel>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={projectname}
            onChange={handleprojectChange}
            input={<OutlinedInput label="Tag" />}
            renderValue={
              (selected) =>
                selected
                  .map((id) => {
                    const selectedItem = allProjects.find((item) => item._id === id);
                    return selectedItem ? selectedItem.name : '';
                  })
                  .join(', ') // دمج الأسماء مع الفاصلة بين كل عنصر
            }
            MenuProps={MenuProps}
          >
            {allProjects.map((projectitem) => (
              <MenuItem key={projectitem._id} value={projectitem._id}>
                <Checkbox checked={projectname.includes(projectitem._id)} />
                <ListItemText
                  primary={`${projectitem.name} --- (${projectitem.developer ? projectitem.developer.name : ''})`}
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <div
        className="d-flex justify-content-center my-3"
        style={{ textAlign: 'center', alignItems: 'center' }}
      >
        <div>Activation</div>
        <Switch
          checked={checked}
          onChange={handleChangeswitch}
          inputProps={{ 'aria-label': 'controlled' }}
        />
        {checked === true ? <div>Active</div> : <div>Not Active</div>}
      </div>
      <div
        onClick={AddRotation}
        className="w-100 btn btn-primary mx-2  my-4"
        style={{ background: '#0F7687', border: 'none' }}
      >
        Save <BeenhereIcon />
      </div>

      {/* <form onSubmit={handleSubmit}>
      <input
        type="text"
        name="name"
        value={leadInfo.name}
        onChange={handleChangeemail}
        placeholder="Lead Name"
      />
      <input
        type="email"
        name="email"
        value={leadInfo.email}
        onChange={handleChangeemail}
        placeholder="Lead Email"
      />
      <button type="submit">Submit Lead</button>
    </form>
  ); */}
      {/* =================================== */}
    </Container>
  );
};
